// useOnMount customHook
import { useRef, EffectCallback } from "react";

import useIsomorphicLayoutEffect from "./useIsomorphicLayoutEffect";

const useOnMount = (callback: EffectCallback) => {
  const mounted = useRef(false);

  useIsomorphicLayoutEffect(() => {
    if (mounted.current) return;
    const destructor = callback();

    return () => {
      mounted.current = true;
      destructor?.();
    };
  }, [callback]);
};

export default useOnMount;
